import { makeStyles } from "@material-ui/core/styles";
import { basePallet } from "./baseStyles";

export const useTextStyles = makeStyles((theme) => ({
  subHeading: {
    fontWeight: 500,
    fontSize: 32,
    color: basePallet.primary.main,
  },
  normalTextBlack: {
    fontWeight: 500,
    fontSize: 18,
    color: "#000000",
  },
  bigTextBlack: {
    fontWeight: 500,
    fontSize: 32,
    color: "#000000",
  },
}));
